import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import Pillars from './pillars';
import {toJS} from "../hocs/toJs";
import {formValueSelector} from "redux-form/immutable";

const selector = formValueSelector('sortPillarsForm');

const parsePillars = (pillars) => {
  const parsedPillars = [];
  pillars.valueSeq().toArray().forEach( pillar => (
    parsedPillars.push({
      id: pillar.get('id'),
      name: pillar.get('name'),
      weightOld: pillar.get('weightOld'),
      weightNew: pillar.get('weightNew'),
      weightNewComing: pillar.get('weightNewComing'),
      createdDate: pillar.get('createdDate'),
    })));
  return parsedPillars;
};

class PillarsHOC extends Component {

  componentDidMount() {
    this.props.getPillars({filter:{where: {or: [{deleted: false}, {deleted: null}]}}});
  }


  render(){
    return (
      <Pillars
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    pillars: state.pillars.get('pillars'),
    loading: state.pillars.get('fetching'),
    pillarsErrors: state.pillars.get('errors'),
    deletingPillar: state.pillar.get('deleting'),
    mobileViewSortBy: selector(state, 'sortBy'),
    mobileViewSortOrder: selector(state, 'sortOrder'),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPillars: (payload) => {
      dispatch(actions.getPillars(payload))
    },
    changePillarsState: (payload) => {
      dispatch(actions.changePillarsState(payload))
    },
    deletePillar: (payload) => {
      dispatch(actions.deletePillar(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PillarsHOC));



// WEBPACK FOOTER //
// ./src/components/pillars/pillarsHOC.js